import s from './Title.module.scss';

const WaveIcon = () => (
  <svg className={s.wave} viewBox="0 0 58 10">
    <path d="M1 5C5 1 9 1 13 5C17 9 21 9 25 5C29 1 33 1 37 5C41 9 45 9 49 5C52 2 55 2 57 5" />
  </svg>
);

const Title = ({ kicker, title }) => {
  return (
    <div className={s.root}>
      {kicker && (
        <p className={s.kicker}>
          {kicker}
        </p>
      )}
      <h2 className={s.title}>
        {title}
        <WaveIcon />
      </h2>
    </div>
  );
};

export default Title;
